// extracted by mini-css-extract-plugin
export var actionRow = "_mu-6";
export var card = "_mu-0";
export var chevron = "_mu-5";
export var content = "_mu-2";
export var details = "_mu-3";
export var eventActionToggle = "_mu-4";
export var icon = "_mu-1";
export var iconBlue = "_mu-8";
export var iconBrand = "_mu-7";
export var iconGrayBlue = "_mu-9";
export var iconGreen = "_mu-a";
export var iconIndigo = "_mu-b";
export var iconOrange = "_mu-c";
export var iconPurple = "_mu-d";
export var iconRed = "_mu-e";
export var iconWarning = "_mu-f";